<template>
  <div class="sections-container">
      <div v-for="section in sections" :key="section.id_seccion" class="subsection">
        <h3 class="subsection-title" style="">{{ section.titulo_seccion }}</h3>
        <ul class="file-list">
          <li v-for="archivo in section.archivos_seccion" :key="section.id_seccion" class="file-item">
            {{ archivo.titulo }}
            <a v-if="archivo.url_pdf" :href="urlServe + archivo.url_pdf" target="_blank" class="file-link pdf-link">
              <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
            </a>
            <a v-if="archivo.url_word" :href="urlServe + archivo.url_word" target="_blank" class="file-link word-link">
              <i class="fas fa-file-word icono-archivo icon-word"></i>
            </a>
            <a v-if="archivo.url_excel" :href="urlServe + archivo.url_excel" target="_blank" class="file-link excel-link">
              <i class="fas fa-file-excel icono-archivo icon-excel"></i>
            </a>
            <a v-if="archivo.url_comprimido" :href="urlServe + archivo.url_comprimido" target="_blank" class="file-link compressed-link">
              <i class="fas fa-file-archive icono-archivo icon-rar"></i>
            </a>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true
    }
  }
};
</script>
<style scoped>
.sections-container {
  padding: 20px;
}
.section-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}
.subsection-title {
  font-size: 20px;
  color: #555;
  margin-top: 15px;
  margin-bottom: 10px;
  border-bottom: 1px solid #cccbcb;
}
.file-list {
  list-style: none;
  padding: 0;
  margin-top: 5px;
}
.file-item {
  margin: 5px 0;
  /* border-bottom: 1px solid red; */
}
.file-link {
  margin-left: 2rem;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.2rem;
  padding: 3px 5px;
  border-radius: 5px;
}
.pdf-link {
  color: #e74c3c;
}
.excel-link {
  color: #27ae60;
}
.file-link:hover {
  background-color: #f0f0f0;
}
</style>
